import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userGuestNotificationMessages = {
  [AutomationEventTypes.GuestCreated]: {
    subject: 'New Guest Added to AdvanceCM – *|GUEST:NAME|*',
    message: `
      Hi Team,

      A new guest has been successfully added to the AdvanceCM.

      Guest Details:
      Full Name: *|GUEST:NAME|*
      Email: *|GUEST:EMAIL|*
      Phone Number: *|GUEST:PHONE|*

      Please review the guest details inside AdvanceCM.
      `,
  },
  [AutomationEventTypes.GuestUpdated]: {
    subject: 'Guest Details Updated – *|GUEST:NAME|*',
    message: `
      Hi Team,

      Some Information for the following guest has been updated:

      Guest Details:
      Full Name: *|GUEST:NAME|*
      Email: *|GUEST:EMAIL|*
      Phone Number: *|GUEST:PHONE|*

      Please login inside AdvanceCM and review the updated details to ensure everything is accurate and any necessary actions are taken promptly.
      `,
  },
}

export const guestNotificationMessages = {}
